import { NextPage } from 'next';
import { useTranslation } from 'next-i18next';
import Head from 'next/head';
import Header from 'src/common/components/Header';
import Layout from 'src/common/components/Layout';
import DescriptionMetaTag from 'src/common/components/MetaTags/DescriptionMetaTag';
import handleApiErrors from 'src/common/utils/handleApiErrors';
import serverGetUser from 'src/common/utils/serverGetUser';
import withCommonMiddleware from 'src/common/utils/withCommonMiddleware';
import SearchInputProvider from 'src/common/components/Search/SearchInputProvider';
import ContactUs from 'src/contact-us/components/Root';
import { loadTranslations } from 'src/common/utils/serverSidePropsHelpers';

type ContactUsPageProps = {};

const ContactUsPage: NextPage<ContactUsPageProps> = () => {
  const [t] = useTranslation('contact-us');

  return (
    <>
      <Head>
        <title>{t('title')}</title>
      </Head>
      <DescriptionMetaTag content={t('meta-description')} />
      <Layout overscrollColor="ivory">
        <SearchInputProvider>
          <Header
            variant="ivory"
            withSearch
            showBottomBorderOnScroll
          />
          <ContactUs />
        </SearchInputProvider>
      </Layout>
    </>
  );
};

export const getServerSideProps = handleApiErrors(
  withCommonMiddleware<ContactUsPageProps>(
    async (context) => {
      const userPromise = serverGetUser(context);
      const translationPromise = loadTranslations(
        context.locale,
        [
          'common',
          'contact-us',
          'pitch-page-browse-boats',
          'navbar',
          'destination-navigation',
          'search-and-filters',
          'boat-categories',
          'footer',
        ],
      );

      return {
        props: {
          user: await userPromise,
          ...(await translationPromise),
        },
      };
    },
  ),
);

export default ContactUsPage;
